/* # =================================================================
# ギャラリーページで使用するスワイパー
# ================================================================= */

/* スワイパーを使用する際の指定 */
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

export default function singleGallerySwiper() {
	if (document.body.classList.contains('single-photo_gallery')) {
		//サムネイル用の指定
		const sliderThumbnail = new Swiper('.swiper-thumbnail', {
			slidesPerView: 5,
		});

		//スライダー用の指定
		const slider = new Swiper('.swiper-single-gallary', {
			loop: true,
			slidesPerView: 1,
			speed: 400,
			centeredSlides: true,
			effect: 'coverflow', // エフェクトを追加
			coverflowEffect: {
				rotate: 50,
				stretch: 0,
				depth: 100,
				modifier: 1,
				slideShadows: true,
			},

			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},

			thumbs: {
				swiper: sliderThumbnail,
			},
		});
	}
}
